module.exports = __webpack_public_path__ + "03bd9ec862668115356d091f9819ed80.svg";